import { render, staticRenderFns } from "./boundrySelectorComponent.vue?vue&type=template&id=2df63f5d&"
import script from "./boundrySelectorComponent.vue?vue&type=script&lang=js&"
export * from "./boundrySelectorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports